module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-checkbox/b-checkbox.component.css
// module id = ./src/app/parts/b-checkbox/b-checkbox.component.css
// module chunks = main